import api from './api';
import apiNoHeaders from './apiNoHeaders';
import idbService from './idbService';
import { createPedidoModel } from '../utils/pedidoUtils';

// idb store name
const storeName = 'saidas';

// Recurso SQL Api Syclus
const environment = process.env.NODE_ENV;
const configLocal = localStorage.getItem('configPedidos');
const host = configLocal ? JSON.parse(configLocal).host : '';
const apiRequest = environment === 'production' ? api : apiNoHeaders;
const baseURL = environment === 'production' ? `erp?url=${host}` : host;
const endpoint = 'saida';
const idColaborador = configLocal ? JSON.parse(configLocal).idColaborador : '';

export const pedidoService = {
  getPedidos,
  getPedidosAPI,
  getPedido,
  generatePedido,
  addPedido,
  addPedidos,
  updatePedido,
  deletePedido,
  sendPedidoAPI,
  compareAndUpdatePedidos
};

function getPedidos() {
  // Fetch indexedDB Items
  // const itemsIndexedDB = await getIndexedDBPedidos();
  // if (itemsIndexedDB.length) return itemsIndexedDB;
  // return getPedidosAPI();
  return getIndexedDBPedidos();
}

function sendPedidoAPI(pedido) {
  // Envia o pedido via POST
  // const item = convertValoresMonetarios(pedido);
  return apiRequest.post(`${baseURL}/saida?Acao=registro`, {
    dados: pedido
  });
}

async function getPedidosAPI() {
  const response = await apiRequest.post(`${baseURL}/${endpoint}`, {
    campos: [
      "id_empresa",
      "id_saida",
      "data_emissao",
      "id_cliente",
      "razao_social",
      "nome_fantasia",
      "total_bruto",
      "total_desconto",
      "total_produto",
      "id_condicao_pagamento",
      "condicao_pagamento",
      "id_tabela_preco",
      "tabela_preco",
      "status",
      "itens",
      "parcelas"
    ],
    filtros: [
      {
        campo: "status",
        criterio: "igual",
        valor: "A"
      },
      {
        campo: "id_colaborador",
        criterio: "igual",
        valor: idColaborador
      }
    ]
  }, {
    params: {
      Acao: 'lista'
    }
  });
  const pedidosApi = environment === 'production' ? response.data.result || [] : response.data || [];

  await compareAndUpdatePedidos(pedidosApi);
  await removeInexistentes(pedidosApi);
  return getIndexedDBPedidos();
}

function getIndexedDBPedidos() {
  return idbService.getAll(storeName);
}

function getPedido(id) {
  return idbService.getById(storeName, id);
}

function getPedidoFromIndex(indexName, id) {
  return idbService.getFromIndex(storeName, indexName, id);
}

async function compareAndUpdatePedidos(pedidos) {
  if (pedidos && pedidos.length) {
    for (const pedido of pedidos) {
      const savedPedido = await getPedidoFromIndex('id_saida', pedido.id_saida);
  
      if (savedPedido) {
        pedido.id_interno = savedPedido.id_interno;
        await updatePedido(pedido);
      }
    }
  }
}

async function removeInexistentes(pedidosApi) {
  const idsPedidosApi = pedidosApi.map(pedidoApi => pedidoApi.id_saida);
  const pedidosLocal = await idbService.getAll(storeName);
  const pedidosInexistentes = pedidosLocal.filter(pedidoLocal => !idsPedidosApi.includes(pedidoLocal.id_saida));
  if (pedidosInexistentes && pedidosInexistentes.length) {
    for (const pedido of pedidosInexistentes) {
      if (pedido.id_saida) {
        await deletePedido(pedido.id_interno);
      }
    }
  }
}

async function addPedido(pedido) {
  return idbService.addToStore(storeName, pedido);
}

async function addPedidos(pedidos = []) {
  const parsedPedidos = pedidos.map(pedido => createPedidoModel(pedido));
  return idbService.addMultipleToStore(storeName, parsedPedidos);
}

async function generatePedido(pedido) {
  if (pedido.status.startsWith('A')) {
    return Promise.reject('Pedido com status A já enviado');
  }

  try {
    const response = await sendPedidoAPI(pedido);
    pedido.id_saida = Number(process.env.NODE_ENV === 'production' ? response.data.result.id_saida : response.data.id_saida);
    pedido.status = 'A';
    delete pedido.versao_imp;
    await updatePedido(pedido);
    return Promise.resolve(pedido);
  } catch (error) {
    return Promise.reject(error);
  }
}

async function updatePedido(pedido) {
  const parsedPedido = createPedidoModel(pedido);
  await idbService.updateItem(storeName, parsedPedido);
}

async function deletePedido(id) {
  await idbService.deleteFromStore(storeName, id);
}

// function convertValoresMonetarios(item) {
//   item.itens.forEach(ii => {
//     ii.preco_bruto = ii.preco_bruto.toString().replace('.', ',');
//     ii.desconto = ii.desconto.toString().replace('.', ',');
//     ii.qtde_produto = ii.qtde_produto.toString().replace('.', ',');
//     ii.qtde_unidade = ii.qtde_unidade.toString().replace('.', ',');
//   });
//   return item;
// }